import React from 'react'
import ViewSvg from 'images/modules/Manage/i-view.svg?raw'

export { default as ViewUrl } from 'images/modules/Manage/i-view.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ViewSvg}} />
)
